import { augmentCarbarUrl } from '../utils/api.js'
import { resolveApiBaseUrl } from '../utils/web-api.js'

export const $fetchForApi = (url, options) => {
	const accessToken = apiAccessToken()
	let fetchOptions = { ...options }

	fetchOptions.headers = {
		...fetchOptions.headers,
		Accept: 'application/json',
		Authorization: `Bearer ${accessToken}`,
	}

	// Get tenant key if partner route.
	fetchOptions = usePartnerHeaders(fetchOptions)

	let env = null
	const runtimeconfig = useRuntimeConfig()

	if (import.meta.server) {
		fetchOptions.baseURL = resolveApiBaseUrl(url, {
			apiUrl: process.env.NUXT_PUBLIC_API_URL,
			// Server side: call the proxy target directly rather than the relative /api base.
			webApiUrl:
				process.env.NUXT_WEB_API_PROXY_TARGET ||
				process.env.NUXT_PUBLIC_WEB_API_URL,
		})
		env = process.env.NUXT_PUBLIC_NODE_ENV
	} else {
		fetchOptions.baseURL = resolveApiBaseUrl(url, {
			apiUrl: runtimeconfig.public.API_URL,
			webApiUrl: runtimeconfig.public.WEB_API_URL,
		})
		env = runtimeconfig.public.NODE_ENV
	}

	return $fetch(augmentCarbarUrl(url, env), fetchOptions)
}
